import { State, process } from '@progress/kendo-data-query';
import { Grid, GridDataStateChangeEvent, GridPagerSettings } from '@progress/kendo-react-grid';
import { createRef, useCallback, useMemo, useState } from 'react';
import useLineItemSummariesColumns from 'src/assets/static/view_invoice/useViewInvoicesLineItemSummaryColumns';
import GridWrapper from 'src/components/GridWrapper';
import useWindowSize from 'src/hooks/useWindowSize';
import useLineItemSummariesApi, {
  ILineItemSummariesResponse,
} from 'src/services/useLineItemSummariesApi';

const gridPagerSettings: GridPagerSettings = {
  buttonCount: 5,
  pageSizes: [10, 20, 50, 100],
};
const defaultProps = {
  showColumnMenu: false,
  resizable: true,
  sortable: false,
  DataItemKey: 'poId',
  pageable: gridPagerSettings,
} as const;

interface ILineItemSummariesWizard {
  poId: number;
}

const initialInvoiceDataState: State & { skipCalculatingTotalRecordsCount: boolean } = {
  skip: 0,
  take: 20,
  skipCalculatingTotalRecordsCount: false,
  sort: [
    {
      field: 'statusDate',
      dir: 'desc',
    },
  ],
  filter: {
    filters: [],
    logic: 'and',
  },
};

const LineItemSummariesWizard: React.FC<ILineItemSummariesWizard> = ({ poId }) => {
  const { height } = useWindowSize();
  const { lineItemSummaries, lineItemSummariesLoading } = useLineItemSummariesApi(poId);
  const tableRef = createRef<Grid>();
  const columns = useLineItemSummariesColumns(tableRef);
  const [dataState, setDataState] = useState<State>(initialInvoiceDataState);

  const { data, total } = useMemo(
    () =>
      process(lineItemSummaries || [], dataState) as {
        data: ILineItemSummariesResponse[];
        total: number;
      },
    [dataState, lineItemSummaries]
  );
  const onInvoiceDataStateChange = useCallback(
    (e: GridDataStateChangeEvent) => setDataState(e.dataState),
    []
  );

  return (
    <>
      <div className="mt-1 mb-1 px-1">
        <GridWrapper
          id="poItemCompletedGrid"
          height={height > 420 ? '75vh' : '700px'}
          loading={lineItemSummariesLoading}
          columns={columns}
          ref={tableRef}
          dataSource={data || []}
          dataState={dataState}
          total={total}
          onDataStateChange={onInvoiceDataStateChange}
          {...defaultProps}
          className="poItemCompletedGrid viewInvoiceModalGrid"
        />
      </div>
    </>
  );
};

export default LineItemSummariesWizard;
